/* nav workstream: header menu behaviour.
   - Desktop (>= 990 px): "Products" mega panel and "Help" dropdown open on hover (mouse) or click/tap,
     close on Escape (focus returns to the trigger), click outside, or focus leaving.
   - Phone/tablet (< 990 px): hamburger opens a full-height drawer (dialog): focus trap, Escape, scroll lock.
   - Remembered Mac (N02): the dock links get ?variant=<id> when localStorage "asc.mac" holds one of the four
     single-dock variant IDs (data-macs on the dock row). Read on every open, never written here. */
(function () {
  'use strict';
  if (window.__ascNav) return;
  window.__ascNav = true;

  var MAC_KEY = 'asc.mac';
  var desk = window.matchMedia('(min-width: 990px)');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function headerSection() { return document.querySelector('.section-header') || document.querySelector('[id$="__header"]'); }
  function headerBottom() {
    var h = $('.header-bg-asc') || $('.header-wrapper') || headerSection();
    if (!h) return 0;
    var b = h.querySelector('header') || h;
    return Math.max(0, Math.round(b.getBoundingClientRect().bottom));
  }

  /* ---------- remembered Mac ---------- */
  function readMac() { try { return window.localStorage.getItem(MAC_KEY) || ''; } catch (e) { return ''; } }
  function macs() {
    var row = $('[data-macs]');
    if (!row) return {};
    try { return JSON.parse(row.getAttribute('data-macs')) || {}; } catch (e) { return {}; }
  }
  function withVariant(href, id) {
    try {
      var u = new URL(href, location.origin);
      if (id) u.searchParams.set('variant', id); else u.searchParams.delete('variant');
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  var macId = '';
  function applyMac() {
    var id = String(readMac()).replace(/[^0-9]/g, '');
    var map = macs();
    macId = id && map[id] ? id : '';
    $$('[data-asc-dock-link]').forEach(function (a) {
      if (a.hasAttribute('data-asc-nav-cta') || a.hasAttribute('data-asc-nav-ph')) {
        if (a.getAttribute('data-state') && a.getAttribute('data-state') !== 'dock') return;
      }
      if (!a.dataset.base) a.dataset.base = a.getAttribute('href');
      a.setAttribute('href', withVariant(a.dataset.base, macId));
    });
    $$('[data-asc-mac-line]').forEach(function (el) {
      if (macId) { $('[data-asc-mac-name]', el).textContent = map[macId]; el.hidden = false; }
      else el.hidden = true;
    });
    if (cta && (!cta.getAttribute('data-state') || cta.getAttribute('data-state') === 'dock')) cta.textContent = dockLabel();
  }

  /* ---------- desktop panels ---------- */
  var openName = null, openTimer = null, closeTimer = null;
  function trig(name) { return $('[data-asc-nav-trigger="' + name + '"]'); }
  function panel(name) { return $('[data-asc-nav-panel="' + name + '"]'); }
  var scrim = null;

  function setHeaderOpen(on) {
    var hs = headerSection();
    if (hs) hs.classList.toggle('menu-open', on);
    document.documentElement.classList.toggle('asc-nav-panel-open', on);
  }

  function show(name) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (openName === name) return;
    if (openName) hide(false, true);
    var p = panel(name), t = trig(name);
    if (!p || !t) return;
    if (name === 'products') { applyMac(); resetPhoto(); preloadPreviews(); }
    p.hidden = false;
    t.setAttribute('aria-expanded', 'true');
    openName = name;
    setHeaderOpen(true);
    if (name === 'products') {
      var top = headerBottom();
      p.style.maxHeight = Math.max(240, window.innerHeight - top) + 'px';
      if (scrim) { scrim.style.top = top + 'px'; scrim.hidden = false; }
    }
  }
  function hide(returnFocus, keepHeader) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!openName) return;
    var p = panel(openName), t = trig(openName);
    if (p) p.hidden = true;
    if (t) t.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    var was = t;
    openName = null;
    if (!keepHeader) setHeaderOpen(false);
    if (returnFocus && was) was.focus();
  }

  /* photo follows the row under the mouse */
  var ph, phImg, capB, capS, cta;
  function setPhoto(src, b, s, label, href, state, fit, w, pos, alt) {
    if (!phImg) return;
    if (src && phImg.getAttribute('src') !== src) phImg.setAttribute('src', src);
    // fr3 #13: a row can set its own crop (e.g. the tray photo keeps both handles) and its own alt; the dock row keeps the CSS default
    if (pos) phImg.style.objectPosition = pos; else phImg.style.removeProperty('object-position');
    phImg.setAttribute('alt', alt || '');
    // fr1 #5: packshots are shown whole on the light tile and never enlarged past half their pixel width (sharp at 2x)
    if (ph) {
      ph.classList.toggle('is-contain', fit === 'contain');
      if (fit === 'contain' && w) phImg.style.setProperty('--asc-nat', Math.round(w / 2) + 'px'); else phImg.style.removeProperty('--asc-nat');
    }
    if (capB) capB.textContent = b || '';
    if (capS) capS.textContent = s || '';
    if (state === 'dock') label = dockLabel();
    if (cta) { cta.textContent = label || cta.getAttribute('data-default'); cta.setAttribute('href', href); cta.setAttribute('data-state', state); }
    if (ph) { ph.setAttribute('href', href); ph.setAttribute('data-state', state); }
  }
  // Design rule 5: "Choose your MacBook" while the Mac is unknown, "See the dock →" once it is remembered.
  function dockLabel() { return macId ? 'See the dock →' : (cta ? cta.getAttribute('data-default') : ''); }
  function resetPhoto() {
    if (!phImg) return;
    var dock = $('.asc-nav-row[data-asc-dock-link]');
    var href = dock ? dock.getAttribute('href') : (cta && cta.getAttribute('href'));
    setPhoto(phImg.getAttribute('data-default'), capB && capB.getAttribute('data-default'), capS && capS.getAttribute('data-default'),
      cta && cta.getAttribute('data-default'), href, 'dock', 'cover', 0);
  }
  var preloaded = false;
  function preloadPreviews() {
    if (preloaded) return; preloaded = true;
    $$('.asc-nav-row[data-photo]').forEach(function (r) { var im = new Image(); im.decoding = 'async'; im.src = r.getAttribute('data-photo'); });
  }
  function rowHover(row) {
    $$('.asc-nav-row.is-hov').forEach(function (r) { if (r !== row) r.classList.remove('is-hov'); });
    if (!row.hasAttribute('data-photo')) return;
    var isDock = row.hasAttribute('data-asc-dock-link');
    setPhoto(row.getAttribute('data-photo'), row.getAttribute('data-cap-b'), row.getAttribute('data-cap-s'),
      row.getAttribute('data-cta'), row.getAttribute('href'), isDock ? 'dock' : 'other',
      row.getAttribute('data-photo-fit'), parseInt(row.getAttribute('data-photo-w'), 10) || 0,
      row.getAttribute('data-photo-pos'), row.getAttribute('data-photo-alt'));
  }

  function initDesktop() {
    scrim = $('[data-asc-nav-scrim]');
    ph = $('[data-asc-nav-ph]'); phImg = ph && ph.querySelector('img');
    capB = $('[data-asc-cap-b]'); capS = $('[data-asc-cap-s]'); cta = $('[data-asc-nav-cta]');
    if (scrim) {
      // keep the scrim out of the sticky header's stacking context quirks: it is fixed, so it covers the page
      scrim.addEventListener('click', function () { hide(false); });
    }

    $$('[data-asc-nav-trigger]').forEach(function (t) {
      var name = t.getAttribute('data-asc-nav-trigger');
      var p = panel(name);
      if (!p) return;
      t.setAttribute('role', 'button');
      t.addEventListener('click', function (e) {
        if (!desk.matches) return;
        e.preventDefault();
        if (openName === name) hide(false); else show(name);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); t.click(); }
        if (e.key === 'Tab' && !e.shiftKey && openName === name) {
          var f0 = p.querySelector('a[href]:not([tabindex="-1"])');
          if (f0) { e.preventDefault(); f0.focus(); }
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault(); show(name);
          var first = p.querySelector('a[href]'); if (first) first.focus();
        }
      });
      [t, p].forEach(function (el) {
        el.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse' || !desk.matches || !hoverable.matches) return;
          clearTimeout(closeTimer);
          if (openName === name) return;
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { show(name); }, openName ? 0 : 120);
        });
        el.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse' || !desk.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { if (openName === name) hide(false); }, 280);
        });
      });
      // the panel sits after the header in the DOM: Tab past its last link goes on to the next top item,
      // Shift+Tab before its first link goes back to the trigger
      p.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var links = Array.prototype.filter.call(p.querySelectorAll('a[href]:not([tabindex="-1"])'), function (a) { return a.offsetParent !== null; });
        if (!links.length) return;
        if (e.shiftKey && document.activeElement === links[0]) { e.preventDefault(); t.focus(); }
        else if (!e.shiftKey && document.activeElement === links[links.length - 1]) {
          var items = $$('.asc-nav__top-item'); var nx = items[items.indexOf(t) + 1];
          e.preventDefault(); hide(false); if (nx) nx.focus();
        }
      });
      p.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (to && (p.contains(to) || t.contains(to))) return;
        if (to && openName === name) hide(false);
      });
    });

    $$('[data-asc-nav-row]').forEach(function (row) {
      row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') rowHover(row); });
      row.addEventListener('focus', function () { rowHover(row); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openName) { e.preventDefault(); hide(true); }
    });
    document.addEventListener('click', function (e) {
      if (!openName) return;
      var p = panel(openName), t = trig(openName);
      if ((p && p.contains(e.target)) || (t && t.contains(e.target))) return;
      hide(false);
    });
    desk.addEventListener('change', function () { hide(false); });
    window.addEventListener('resize', function () {
      if (openName === 'products') { var p = panel('products'); p.style.maxHeight = Math.max(240, window.innerHeight - headerBottom()) + 'px'; }
    });
  }

  /* ---------- phone drawer ---------- */
  var drawer, burger, lastFocus = null;
  function focusables() {
    // fix round 3 (#9): Selecty's button lives in a shadow root; its host stands in for it in the Tab cycle
    var list = [burger].concat($$('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"]), selector-root', drawer));
    return list.filter(function (el) {
      if (!el || el.offsetParent === null) return false;
      if (el.tagName === 'SELECTOR-ROOT') return !!(el.shadowRoot && el.shadowRoot.querySelector('button'));
      return true;
    });
  }
  function focusIt(el) {
    if (el && el.tagName === 'SELECTOR-ROOT') { var b = el.shadowRoot && el.shadowRoot.querySelector('button'); if (b) { b.focus(); return; } }
    if (el) el.focus();
  }
  function openDrawer() {
    if (!drawer || !drawer.hidden) return;
    applyMac();
    lastFocus = document.activeElement;
    var hs = headerSection();
    if (hs) { hs.classList.remove('shopify-section-header-hidden'); hs.classList.add('menu-open'); }
    document.documentElement.style.setProperty('--asc-nav-top', headerBottom() + 'px');
    document.documentElement.classList.add('asc-nav-drawer-open');
    drawer.hidden = false;
    drawer.scrollTop = 0;
    // header can move (announcement scrolled away) once the page stops scrolling: measure again
    requestAnimationFrame(function () { document.documentElement.style.setProperty('--asc-nav-top', headerBottom() + 'px'); });
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', burger.getAttribute('data-label-close') || 'Close menu');
    var first = drawer.querySelector('a[href]:not([tabindex="-1"])');
    if (first) first.focus({ preventScroll: true });
  }
  function closeDrawer(returnFocus) {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('asc-nav-drawer-open');
    var hs = headerSection();
    if (hs) hs.classList.remove('menu-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', burger.getAttribute('data-label-open') || 'Open menu');
    if (returnFocus !== false) burger.focus({ preventScroll: true });
  }
  function initDrawer() {
    drawer = $('[data-asc-nav-drawer]'); burger = $('[data-asc-nav-burger]');
    if (!drawer || !burger) return;
    burger.addEventListener('click', function () { if (drawer.hidden) openDrawer(); else closeDrawer(true); });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(true); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && (i <= 0)) { e.preventDefault(); focusIt(f[f.length - 1]); }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); focusIt(f[0]); }
      }
    });
    // following a link: close first so the page under it is unlocked (bfcache restores clean)
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a) closeDrawer(false);
    });
    desk.addEventListener('change', function () { if (desk.matches) closeDrawer(false); });
    window.addEventListener('pageshow', function () { closeDrawer(false); hide(false); });
    // the cart drawer opening on top: close the menu
    document.addEventListener('asc:cart:open', function () { closeDrawer(false); hide(false); });
  }

  /* ---------- in-page tabs on product pages: hide tabs whose section is missing ---------- */
  function tidyTabs() {
    var wrap = $('.id-tab-listwrap');
    if (!wrap) return;
    var shown = 0;
    $$('.id-tab-list li a[href^="#"]', wrap).forEach(function (a) {
      var ok = !!document.getElementById(a.getAttribute('href').slice(1));
      a.parentNode.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    if (shown < 2) wrap.style.display = 'none';
    scrollPad();
    var sh = document.querySelector('sticky-header');
    if (sh && typeof sh.setHeaderHeight === 'function') { sh.setHeaderHeight(); window.addEventListener('resize', function () { sh.setHeaderHeight(); }); }
  }

  /* scrollIntoView / anchor jumps clear the sticky header and the in-page tabs (defect P-O1) */
  function scrollPad() {
    var h = $('.header-asc'), tabs = $('.id-tab-listwrap');
    if (!h) return;
    var th = tabs && tabs.offsetParent !== null && tabs.style.display !== 'none' ? tabs.offsetHeight : 0;
    document.documentElement.style.scrollPaddingTop = (h.offsetHeight + th + 8) + 'px';
  }

  /* fix round 2 (N-5): Selecty renders its button in an open shadow root that page CSS can't reach; add a visible
     keyboard focus ring there (violet with a white halo, readable on the white header and the dark drawer/footer) */
  function selectyFocus() {
    var css = '.sel-disclosure-btn:focus-visible,button:focus-visible,[role="listbox"]:focus-visible,[role="option"]:focus-visible{outline:2px solid #5132F5!important;outline-offset:2px!important;box-shadow:0 0 0 4px #fff!important;border-radius:6px}';
    var tries = 0;
    (function tick() {
      var pending = 0;
      $$('selector-root').forEach(function (el) {
        if (!el.shadowRoot || !el.shadowRoot.querySelector('button, a, select')) { pending++; return; }
        var box = el.closest('.asc-nav-drawer__mkt'); if (box) box.classList.add('is-ready');
        if (el.shadowRoot.querySelector('style[data-asc-focus]')) return;
        var st = document.createElement('style'); st.setAttribute('data-asc-focus', ''); st.textContent = css;
        el.shadowRoot.appendChild(st);
      });
      if ((pending || !$$('selector-root').length) && ++tries < 120) setTimeout(tick, 500);
    })();
  }

  /* fix round 3 (#1): until publish-day template assignment, footer links to the old Shogun pages open the native asc-*
     templates (same rule as snippets/asc-nav-url.liquid; the footer is another section, so the header's flag drives it) */
  var VIEWS = { faqs: 'asc-faqs', shipping: 'asc-shipping', 'about-us': 'asc-about-us', wallpapers: 'asc-wallpapers' };
  function nativeLinks() {
    if (!document.getElementById('asc-nav-views')) return;
    $$('footer a[href*="/pages/"], .footer a[href*="/pages/"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (/[?#]/.test(href)) return;
      var m = href.match(/^(?:https?:\/\/[^/]+)?\/pages\/([^/?#]+)\/?$/);
      if (!m) return;
      if (m[1] === 'returns') { a.setAttribute('href', '/pages/shipping?view=asc-returns'); return; }
      if (VIEWS[m[1]]) a.setAttribute('href', '/pages/' + m[1] + '?view=' + VIEWS[m[1]]);
    });
  }

  function init() {
    nativeLinks();
    selectyFocus();
    scrollPad();
    window.addEventListener('resize', scrollPad);
    window.addEventListener('load', scrollPad);
    initDesktop();
    initDrawer();
    applyMac();
    tidyTabs();
    window.addEventListener('storage', function (e) { if (e.key === MAC_KEY) applyMac(); });
    document.addEventListener('asc:mac:change', applyMac);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
